const dividerStyles = (tokens) => ({
    variants: {
        grey: {
            backgroundColor: tokens.BorderLight500,
            padding: 0.4,
        },
    },
});
export default dividerStyles;
